/**
 * 存储storage
 */
export const setStore = (key, value) => {
    if (!key) return;

    if (typeof value !== 'string') {
        value = JSON.stringify(value);
    }

    window.sessionStorage.setItem(key,value);
    //window.localStorage.setItem(key, value);
}

/**
 * 获取storage
 */
export const getStore = key => {
    if (!key) return;

    return window.sessionStorage.getItem(key);
    //return window.localStorage.getItem(key);
}

/**
 * 删除localStorage
 */
export const removeStore = key => {
    if (!key) return;
    window.sessionStorage.removeItem(key);
    //window.localStorage.removeItem(key);
}

/**
 * 设置cookie
 */
export const setCookie = (key, value, expires) => {
    if (!key) return;

    if (typeof value !== 'string') {
        value = JSON.stringify(value);
    }

    var d = new Date();
    d.setTime(d.getTime() + (expires * 1000));

    document.cookie = key + "=" + value + "; expires=" + d.toGMTString();
}

export const getCookie = key => {
    if (!key) return;

    const reg = new RegExp("(^| )" + key + "=([^;]*)(;|$)");
    const arr = document.cookie.match(reg);

    if (arr)
        return unescape(arr[2]);
    return null;
}

export const removeCookie = key => {
    let d = new Date();
    d.setTime(d.getTime() - 1);

    let val = getCookie(key);
    if (val != null)
        document.cookie = key + "=" + val + ";expires=" + d.toGMTString()+";path=";
}
export const openNewTable = (url) => {
  let dom = document.createElement("a");
  dom.setAttribute("href", url);

  dom.setAttribute("target", "_blank");
  document.body.appendChild(dom);
  dom.click();
  document.body.removeChild(dom);
};